/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {DeleteNotificationsParams} from './schemas/delete-notifications-params';

import type {ListNotificationSubscriptions200} from './schemas/list-notification-subscriptions200';

import type {ListNotificationsParams} from './schemas/list-notifications-params';

import type {ListNotifications200} from './schemas/list-notifications200';

import type {MarkNotificationsAsReadBody} from './schemas/mark-notifications-as-read-body';

import type {MarkNotificationsAsRead200} from './schemas/mark-notifications-as-read200';

import type {UpdateNotificationSubscriptionsBody} from './schemas/update-notification-subscriptions-body';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List user notifications
 */
export const listNotifications = (
  params?: ListNotificationsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListNotifications200>>,
) => {
  return orvalApiFetch<ListNotifications200>(
    {url: `/notifications`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Bulk delete notifications
 */
export const deleteNotifications = (
  params: DeleteNotificationsParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/notifications/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Mark notifications as read
 */
export const markNotificationsAsRead = (
  markNotificationsAsReadBody?: MarkNotificationsAsReadBody,
  options?: SecondParameter<typeof orvalApiFetch<MarkNotificationsAsRead200>>,
) => {
  return orvalApiFetch<MarkNotificationsAsRead200>(
    {
      url: `/notifications/mark-as-read`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: markNotificationsAsReadBody,
    },
    options,
  );
};
/**
 * @summary List notification subscriptions
 */
export const listNotificationSubscriptions = (
  options?: SecondParameter<
    typeof orvalApiFetch<ListNotificationSubscriptions200>
  >,
) => {
  return orvalApiFetch<ListNotificationSubscriptions200>(
    {url: `/notifications/subscriptions`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update notification subscriptions
 */
export const updateNotificationSubscriptions = (
  updateNotificationSubscriptionsBody: UpdateNotificationSubscriptionsBody,
  options?: SecondParameter<typeof orvalApiFetch<string | void>>,
) => {
  return orvalApiFetch<string | void>(
    {
      url: `/notifications/subscriptions`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateNotificationSubscriptionsBody,
    },
    options,
  );
};
export type ListNotificationsResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type DeleteNotificationsResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotifications>>
>;
export type MarkNotificationsAsReadResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsAsRead>>
>;
export type ListNotificationSubscriptionsResult = NonNullable<
  Awaited<ReturnType<typeof listNotificationSubscriptions>>
>;
export type UpdateNotificationSubscriptionsResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationSubscriptions>>
>;
